import cx from 'classnames';
import humanDuration from 'core/libs/helpers/humanDuration';
import Box from 'modules/common/Box';
import dateDiffInDays from 'core/libs/helpers/dateDiffInDays';
import formatDays from 'core/libs/helpers/formatDays';
import BreadCrumbs from 'modules/common/BreadCrumbs';
import Container from 'modules/common/Container';
import Head from 'modules/common/Head';
import HeroBox from 'modules/common/HeroBox';
import MetaItem from 'modules/common/MetaItem';
import NewDesignButton from 'modules/common/NewDesignButton';
import Partnerships from 'modules/common/Partnerships';
import Clock from 'modules/common/Svg/Clock';
import RightArrowAlt from 'modules/common/Svg/RightArrowAlt';
import WriteBoard from 'modules/common/Svg/WriteBoard';
import TrackTime from 'modules/common/TrackTime';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import digitalOcean from 'theme/assets/images/digital-ocean.svg';
import About from './About';
import Instructor from './Instructor';
import NextCourseButton from './NextCourseButton';
import Skills from './Skills';
import Stages from './Stages';
import {
  discordlink,
  buttonsholder,
  titlescontain,
} from '../../containers/styles.scss';

const {PARTNER} = process.env;

const CourseDetails = (props) => {
  const intl = useIntl();
  const {formatMessage} = intl;
  const {
    authenticated,
    courseProgress,
    course,
    courseSlug,
    description,
    duration,
    id,
    isDegree,
    level,
    name,
    refetchCourse,
    skillz,
    slug,
    stages,
    stagesProgress,
    stepsProgress,
    teachers,
    track,
    trackSlug,
    deadline,
    subscription,
  } = props;
  const currentStage =
    stages &&
    (courseProgress === 'completed'
      ? stages[0]
      : stages.find((stage) => stagesProgress[stage.id] !== 'completed'));

  const currentStep =
    currentStage &&
    currentStage.steps &&
    (currentStage.steps.find(
      (step) => stepsProgress[step.id] !== 'completed',
    ) ||
      currentStage.steps[0]);

  let nextStepUrl = isDegree
    ? `/degrees/${trackSlug}/${slug}`
    : `/${trackSlug}/${slug}`;
  if (currentStage) {
    nextStepUrl += `/${currentStage.slug}`;
    if (currentStep) nextStepUrl += `/${currentStep.slug}`;
  }
  const skillzArray = skillz && JSON.parse(skillz);
  const isFirstStepLocked = stages[0]?.steps[0]?.isLocked;
  const isCurrentStepLocked = currentStep?.isLocked;
  // const activatedAtDate = new Date(activatedAt);
  // activatedAtDate.setTime(
  //   activatedAtDate.getTime() + deadline * 24 * 60 * 60 * 1000,
  // );
  // const year = activatedAtDate.toLocaleString('default', {
  //   year: 'numeric',
  // });
  // const month = activatedAtDate.toLocaleString('ar-AR', {
  //   month: 'long',
  // });
  // const day = activatedAtDate.toLocaleString('default', {
  //   day: 'numeric',
  // });
  // const daysLeft = dateDiffInDays(new Date(), activatedAtDate);
  return (
    <div>
      <div className="f5">
        <Head
          name={name}
          title={`${
            name ||
            formatMessage({
              id: 'loading_data',
            })
          } | ${formatMessage({
            id: PARTNER === 'BARMEJ' ? 'helmet_barmej' : 'partner_helmet',
          })}`}
          description={
            description && description.replace(/<\/?[^>]+(>|$)/g, '')
          }
        />
        <TrackTime
          messages={[
            `Time on ${isDegree ? 'degree' : 'track'} ${track.name}`,
            `Time on course ${name}`,
          ]}
        />
        <HeroBox
          cyTitle="course-title"
          title={name}
          metas={
            <div
              className={cx('b flex items-center flex-row-ns flex-column', {
                'justify-center': isDegree,
              })}
            >
              {stages && stages.length && (
                <MetaItem>
                  <WriteBoard color="#86e9b3" className="dib ml2 mt1 v-mid" />
                  <span data-cy="lessons">
                    {stages.length} <FormattedMessage id="courses" />
                  </span>
                </MetaItem>
              )}
              {duration && duration > 0 && (
                <MetaItem cy="duration">
                  <Clock color="#86e9b3" className="dib ml2 mt1 v-mid" />
                  {humanDuration(duration)}
                </MetaItem>
              )}
              {level && (
                <MetaItem isLast cy="level">
                  {level}
                </MetaItem>
              )}
            </div>
          }
          className={cx({
            'bg-black-90': isDegree,
            'bg-darker-primary-blue': !isDegree,
          })}
          isDegree={isDegree}
          isCoursesPage
        >
          <div className={`flex items-center justify-between ${buttonsholder}`}>
            <div
              className={cx('flex-ns items-center', {
                'justify-center': isDegree,
              })}
            >
              <NewDesignButton
                link={isDegree ? `/degrees/${trackSlug}` : `/${trackSlug}`}
                className="link dim ba b--white pa3-ns"
                border={false}
              >
                <RightArrowAlt color="#fff" className="ml2" />
                <FormattedMessage
                  id={isDegree ? 'return_degree' : 'return_track'}
                />
              </NewDesignButton>
              <div className="ph2-ns pv0-ns pv1" />
              {courseProgress === 'not started' && (
                <NewDesignButton
                  className="bg-green-light bg-animate hover-bg-green ph3 pv3"
                  link={ (subscription === 'ACTIVE' || !isFirstStepLocked) ?
                    nextStepUrl : '/subscription'
                  }
                  state = {{ fromLink: nextStepUrl }}
                >
                  <FormattedMessage id="start_course" />
                </NewDesignButton>
              )}
              {courseProgress === 'started' && (
                <NewDesignButton
                  className="bg-green-light bg-animate hover-bg-green ph3 pv3"
                  link={(subscription === 'ACTIVE' || !isCurrentStepLocked ) ?
                    nextStepUrl : '/subscription'
                  }
                  state = {{ fromLink: nextStepUrl }}
                >
                  <FormattedMessage id="course_continue" />
                </NewDesignButton>
              )}
              {courseProgress === 'completed' && (
                <NextCourseButton
                  isDegree={isDegree}
                  trackId={track.id}
                  courseSlug={courseSlug}
                />
              )}
              <div className="ph2-ns pv0-ns pv1" />
            </div>
            <NewDesignButton
              className={`lh-copy ph3 ${discordlink} bg-blue bg-animate hover-bg-dark-blue`}
              link="https://discord.gg/qmVqWbm"
              external
            >
              <FormattedMessage id="do_you_need_help" />
            </NewDesignButton>
          </div>
        </HeroBox>
        <BreadCrumbs
          steps={[
            {
              text: formatMessage({
                id: 'homepage',
              }),
              url: '/',
            },
            {
              text: formatMessage({
              id: 'tracks',
              }),
              url: '/tracks',
            },
            {
              text: track.name,
              url: `${isDegree ? '/degrees' : ''}/${trackSlug}`,
            },
            {
              text: name,
              url: `${isDegree ? '/degrees' : ''}/${trackSlug}/${slug}`,
            },
          ]}
        />
        <Container className="pt5 cf">
          {isDegree && (
            <>
              <div className={`w-80-ns w-100 ${titlescontain}`}>
                <h5 className="f4">
                  <FormattedMessage id="to_do_list" /> <br />
                  <FormattedMessage id="complete_the_following_steps" />
                </h5>
                {/* <h5
                  className="f5 gray"
                  style={{display: daysLeft > 0 ? 'block' : 'none'}}
                >
                  <FormattedMessage
                    id="expected_date"
                    values={{day, month, year, days: formatDays(daysLeft)}}
                  />
                </h5> */}
              </div>
            </>
          )}
          <div className="w-70-l w-100 fr pl3-l tc">
            {!isDegree && (<About description={description} />)}
            <Stages
              authenticated={authenticated}
              courseSlug={slug}
              courseId={id}
              currentStage={currentStage}
              currentStep={currentStep}
              isDegree={isDegree}
              refetchCourse={refetchCourse}
              stages={stages}
              stagesProgress={stagesProgress}
              stepsProgress={stepsProgress}
              trackSlug={trackSlug}
              subscription={subscription}
            />
          </div>
          <div className="w-30-l w-100 fl pr3-ns pr0">
            {skillzArray && skillzArray.length > 0 && (
              <Box>
                <Skills items={skillz} />
              </Box>
            )}
            {teachers &&
              teachers.map((teacher, index) => (
                <Box key={index}>
                  <Instructor {...teacher} />
                </Box>
              ))}

            {track.id === 1017 && (
              <Box>
                <Partnerships source={digitalOcean} width="120" height="160" />
              </Box>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

CourseDetails.propTypes = {
  authenticated: PropTypes.bool,
  courseProgress: PropTypes.string.isRequired,
  course: PropTypes.object.isRequired,
  courseSlug: PropTypes.string.isRequired,
  isDegree: PropTypes.bool,
  description: PropTypes.string,
  duration: PropTypes.number,
  id: PropTypes.number.isRequired,
  level: PropTypes.string,
  name: PropTypes.string,
  refetchCourse: PropTypes.func,
  slug: PropTypes.string,
  skillz: PropTypes.string,
  stages: PropTypes.array.isRequired,
  stagesProgress: PropTypes.object.isRequired,
  stepsProgress: PropTypes.object.isRequired,
  teachers: PropTypes.array.isRequired,
  track: PropTypes.object.isRequired,
  trackSlug: PropTypes.string,
  deadline: PropTypes.number,
  activatedAt: PropTypes.string,
};

export default CourseDetails;
